import React from 'react';

export default props => (
  <svg viewBox={props.viewBox || '0 0 25 25'} style={{ display: 'block', margin: '0 auto' }}>
    <g fill={props.color}>
      <path d="M20,14.5V2H0v18.8c0,2.1,1.7,3.8,3.8,3.8h17.5c2.1,0,3.8-1.7,3.8-3.8v-6.2H20z M4,10.2C4,9.6,4.6,9,5.2,9H11 c0.7,0,1.2,0.6,1.2,1.2v1.5c0,0.7-0.6,1.2-1.2,1.2H5.2C4.6,13,4,12.4,4,11.8V10.2z M14.8,21.1H5.2c-0.7,0-1.2-0.4-1.2-1s0.6-1,1.2-1 h9.5c0.7,0,1.2,0.4,1.2,1S15.4,21.1,14.8,21.1z M14.8,17.1H5.2c-0.7,0-1.2-0.4-1.2-1s0.6-1,1.2-1h9.5c0.7,0,1.2,0.4,1.2,1 S15.4,17.1,14.8,17.1z M16,11.8c0,0.7-0.3,1.2-1,1.2s-1-0.6-1-1.2v-1.5C14,9.6,14.3,9,15,9s1,0.6,1,1.2V11.8z M14.8,7.1H5.2 C4.6,7.1,4,6.7,4,6s0.6-1,1.2-1h9.5C15.4,5,16,5.4,16,6S15.4,7.1,14.8,7.1z M22.5,20.8c0,0.7-0.6,1.2-1.2,1.2S20,21.4,20,20.8V17 h2.5V20.8z" />
    </g>
  </svg>
);
